"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
function SectionButton(_a) {
    var count = _a.count, onClicked = _a.onClicked, active = _a.active, text = _a.text, icon = _a.icon;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)({
            'eva-job__section-button': true,
            active: active,
        }), "data-cy": "moderation-note-button", onClick: onClicked, title: t('ITEM.MODERATION_NOTES.TOGGLE_BUTTON_TOOLTIP') },
        icon,
        react_1.default.createElement("span", null, text),
        react_1.default.createElement("div", { className: "eva-job__section-button__count ".concat((0, clsx_1.default)({
                'eva-job__section-button__count--active': count > 0,
            })) }, count)));
}
exports.default = SectionButton;
